// Make iframe embeded videos from Vimeo and Youtube into responsive videos on blog.

const blogArea = document.querySelector<HTMLElement>('.c-article__content-block-details');
const blogIframes = blogArea?.querySelectorAll('iframe');

blogIframes?.forEach(iframe => {
  if (iframe.src.includes('vimeo') || iframe.src.includes('youtube')) {
    if (iframe.parentElement === blogArea) {
      const wrapperDiv = document.createElement('div');
      wrapperDiv.classList.add('responsive-video-container');
      iframe.parentElement?.replaceChild(wrapperDiv, iframe);
      wrapperDiv.appendChild(iframe);
    } else {
      iframe.parentElement?.classList.add('responsive-video-container');
    }
  }
});